var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBookmarkLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.667 2.664h18.667a1.333 1.333 0 011.333 1.333v25.524a.666.666 0 01-1.021.566l-9.645-6.05-9.646 6.048a.667.667 0 01-1.021-.564V3.997a1.333 1.333 0 011.333-1.333zm17.334 2.667H8v20.576l8-5.015 8 5.015V5.33z",
    fill: "gray"
  })));
}

export default SvgIconBookmarkLine;